import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTToolbar = _resolveComponent("KTToolbar")!
  const _component_InnerCategoryComponent = _resolveComponent("InnerCategoryComponent")!
  const _component_FormModal = _resolveComponent("FormModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_KTToolbar, {
      breadcrumbs: _ctx.breadcrumbs,
      title: "",
      routeKey: _ctx.getKey
    }, null, 8, ["breadcrumbs", "routeKey"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDynamicList, (category) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "parent-categories",
        key: category.id
      }, [
        _createVNode(_component_InnerCategoryComponent, {
          category: category,
          routeKey: _ctx.getKey
        }, null, 8, ["category", "routeKey"])
      ]))
    }), 128)),
    _createVNode(_component_FormModal, { routeKey: _ctx.getKey }, null, 8, ["routeKey"])
  ], 64))
}